<div
  class="main-container"
  [class.en-popup]="popupMapa"
>
  @if (!loading) {
    <mat-card class="camera-dialog-card" [class.con-encabezado]="header">
      <!-- Header (solo cuando es dialog): encabezado común (A2) -->
      @if (header) {
        <app-card-header
          class="camera-header"
          [title]="tituloComponente"
          icono="videocam"
          margin="10px 16px"
          [botonCerrar]="true"
          (cerrar)="closeDialog()"
          (mousedown)="bringToFront()"
        ></app-card-header>
      }

      <!-- Content -->
      <mat-card-content class="camera-card-content">
        <!-- Vista mosaico -->
        @if (mosaico) {
          <app-multi-camera-mosaic
            [streams]="streamsParaGrid"
            [fechaEvento]="fechaEvento"
            [inicial]="mosaicoInicial"
            (back)="mosaico = false"
          ></app-multi-camera-mosaic>
        }

        <!-- Vista grilla (no maximizado, no mosaico) -->
        @if (!maximizado && !mosaico) {
          <div class="content-toolbar irx-sobre-oscuro">
            <button
              irxBotonIcono
              tamano="compacto"
              (click)="mosaico = true"
              tooltip="Vista mosaico"
            >
              <mat-icon>grid_view</mat-icon>
            </button>
          </div>
          <app-multi-camera-stream
            [streams]="streamsPaginados"
            [gridColumns]="getGridColumns()"
            [popupMapa]="popupMapa"
            (streamClick)="onCameraClick($event)"
          ></app-multi-camera-stream>
        }

        <!-- Vista maximizada -->
        @if (maximizado) {
          <div class="camara-maximizada">
            <!-- Barra de info + controles (siempre visible) -->
            <div class="camara-maximizada__barra irx-sobre-oscuro">
              @if (streamsParaGrid.length > 1) {
                <button
                  irxBotonIcono
                  tamano="compacto"
                  class="btn-controles"
                  (click)="select()"
                  tooltip="Volver"
                >
                  <mat-icon>arrow_back</mat-icon>
                </button>
              }

              <div class="camara-info">
                <span class="camara-info__nombre">
                  {{ camaraActual?.identificacion }}
                </span>
                <span class="camara-info__canal">Canal {{ canalActual }}</span>
              </div>

              <!-- Controles de grabación (siempre visibles cuando maximizado) -->
              <div class="camara-grabacion">
                @if (fechaEvento) {
                  <button
                    irxBoton="secundario"
                    tamano="compacto"
                    class="btn-rewind"
                    (click)="volverAtras(0.5)"
                    tooltip="Retroceder 30 s"
                  >
                    <mat-icon>fast_rewind</mat-icon>
                    <span class="btn-texto">30s</span>
                  </button>
                  <button
                    irxBoton="secundario"
                    tamano="compacto"
                    class="btn-rewind"
                    (click)="volverAtras(1)"
                    tooltip="Retroceder 1 min"
                  >
                    <mat-icon>fast_rewind</mat-icon>
                    <span class="btn-texto">1m</span>
                  </button>
                  <button
                    irxBoton="secundario"
                    tamano="compacto"
                    class="btn-rewind"
                    (click)="volverAtras(3)"
                    tooltip="Retroceder 3 min"
                  >
                    <mat-icon>fast_rewind</mat-icon>
                    <span class="btn-texto">3m</span>
                  </button>
                  <button
                    irxBoton="secundario"
                    tamano="compacto"
                    class="btn-rewind"
                    (click)="volverAtras(5)"
                    tooltip="Retroceder 5 min"
                  >
                    <mat-icon>fast_rewind</mat-icon>
                    <span class="btn-texto">5m</span>
                  </button>
                  <button
                    irxBoton="tonal"
                    tamano="compacto"
                    class="btn-evento"
                    (click)="volverAtras(0)"
                    tooltip="Ir a la hora del evento"
                  >
                    <mat-icon>schedule</mat-icon>
                    <span class="btn-texto">Hora del evento</span>
                  </button>
                } @else {
                  <app-date-picker
                    mode="datetime"
                    [maxDate]="maxFechaDate"
                    [(ngModel)]="fechaSeleccionadaISO"
                    (ngModelChange)="onFechaPickerChange($event)"
                    (confirm)="irAFechaSeleccionada()"
                    class="fecha-picker"
                  ></app-date-picker>
                  <button
                    irxBoton="tonal"
                    tamano="compacto"
                    class="btn-evento"
                    (click)="irAFechaSeleccionada()"
                    tooltip="Ver grabación en la fecha elegida"
                  >
                    <mat-icon>calendar_today</mat-icon>
                    <span class="btn-texto">Ver</span>
                  </button>
                  @if (fecha) {
                    <button
                      irxBoton="secundario"
                      tamano="compacto"
                      class="btn-vivo"
                      (click)="volverAlVivo()"
                      tooltip="Volver a la transmisión en directo"
                    >
                      <mat-icon>live_tv</mat-icon>
                      <span class="btn-texto">Directo</span>
                    </button>
                  }
                }
                <button
                  irxBoton="secundario"
                  tamano="compacto"
                  alternable
                  class="btn-vivo"
                  [activo]="!vivo"
                  (click)="vivo = !vivo"
                  tooltip="Vista en vivo"
                >
                  <mat-icon>live_tv</mat-icon>
                  <span class="btn-texto">Vivo</span>
                </button>
              </div>
            </div>

            <!-- Stream principal -->
            <div class="camara-maximizada__stream" [id]="nombreEntidad">
              <app-stream-camara
                class="stream-principal"
                [esDialog]="false"
                [camara]="camaraActual"
                [canal]="canalActual"
                [mainStream]="true"
                [controles]="true"
                [botonMultiple]="true"
                [maximizado]="maximizado"
                [fecha]="fecha"
                (camaraEmiter)="select()"
              ></app-stream-camara>

              @if (!vivo) {
                <div
                  cdkDrag
                  [cdkDragBoundary]="dragBoundary"
                  class="camara-vivo-preview"
                >
                  <button
                    irxBotonIcono="imagen"
                    tamano="mini"
                    class="preview-close-btn"
                    (click)="vivo = true"
                    (mousedown)="$event.stopPropagation()"
                    tooltip="Cerrar"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                  <app-stream-camara
                    [esDialog]="false"
                    [camara]="camaraActual"
                    [canal]="canalActual"
                    [mainStream]="false"
                    [controles]="false"
                    [botonMultiple]="false"
                    [maximizado]="maximizado"
                  ></app-stream-camara>
                </div>
              }
            </div>
          </div>
        }
      </mat-card-content>
    </mat-card>
  }

  <!-- Controles de paginación (solo cuando hay más de una página) -->
  @if (!maximizado && !mosaico && streamsParaGrid.length > pageSize) {
    <div
      class="camera-pagination"
      [class.camera-pagination--abajo]="paginadorAbajo"
      [class.camera-pagination--compact]="popupMapa"
    >
      @if (!popupMapa) {
        <div class="pagination-info">
          <span class="pagination-rango">{{ getCurrentRangeText() }}</span>
          <span
            class="pagination-teclado"
            tooltip="Usá ← → para navegar, 1-9 para ir a página específica, Home/End para primera/última página"
          >
            <mat-icon class="pagination-teclado__icon">keyboard</mat-icon>
            Navegación con teclado
          </span>
        </div>
      }

      <div class="pagination-controles" [class.compact-inline]="popupMapa">
        <button
          irxBotonIcono="borde"
          tamano="compacto"
          tooltip="Primera página"
          [disabled]="isFirstPage()"
          (click)="goToFirstPage()"
        >
          <mat-icon>first_page</mat-icon>
        </button>
        <button
          irxBotonIcono="borde"
          tamano="compacto"
          tooltip="Anterior"
          [disabled]="isFirstPage()"
          (click)="goToPreviousPage()"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>

        @if (popupMapa) {
          <span class="pagination-texto-compact">
            {{ getCurrentRangeText() }}
          </span>
        } @else {
          <div class="pagination-indicadores">
            @for (page of getPageNumbers(); track page) {
              <button
                irxBotonIcono="borde"
                tamano="compacto"
                [activo]="page === getCurrentPageNumber()"
                [tooltip]="'Ir a la página ' + (page + 1)"
                (click)="goToPage(page)"
              >
                {{ page + 1 }}
              </button>
            }
          </div>
        }

        <button
          irxBotonIcono="borde"
          tamano="compacto"
          tooltip="Siguiente"
          [disabled]="isLastPage()"
          (click)="goToNextPage()"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button
          irxBotonIcono="borde"
          tamano="compacto"
          tooltip="Última página"
          [disabled]="isLastPage()"
          (click)="goToLastPage()"
        >
          <mat-icon>last_page</mat-icon>
        </button>
      </div>
    </div>
  }
</div>
